import { Injectable, inject } from '@angular/core'
import { Filter, HttpParamsBuilder, RestClientList } from '@elderbyte/ngx-starter'
import { HttpClient } from '@angular/common/http'
import { environment } from '../../../../../environments/environment'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { FacilityUtilisation } from './facility-utilisation'
import { Observable } from 'rxjs'
import { UtilisationCommand, UtilisationCommandResult } from './commands/utilisation-command'

@Injectable({
  providedIn: 'root',
})
export class FacilityUtilisationService extends RestClientList<FacilityUtilisation, string> {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/utilisation/facilities', http, {
      idField: 'id',
    })
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public getFacilityUtilisation(
    facilityId: string,
    utilisationFilters: Filter[]
  ): Observable<FacilityUtilisation> {
    return this.findById(
      facilityId,
      HttpParamsBuilder.start().appendFilters(utilisationFilters).build()
    )
  }

  /***************************************************************************
   *                                                                         *
   * Commands                                                                *
   *                                                                         *
   **************************************************************************/

  public executeCommand(cmd: UtilisationCommand): Observable<UtilisationCommandResult> {
    return this.http.post<UtilisationCommandResult>(
      environment.apiPath + '/utilisation/commands',
      cmd
    )
  }
}
